import { ResponsesTypes } from '@/entities/checklist';

/**
 * Check if the header page should be shown. We show header page when either:
 * 1. We have non-automatic & non-entity type of response question inside
 * 2. There is no entity item question and there are more than 1 entity items
 * 3. There is entity item question AND autofill_entity is disabled
 * 4. There is entity item question AND there are more than 1 allowed entity items
 *
 * @param headerPage
 * @param inspection
 * @param user
 * @param allowedEntityItems - list of allowed entity items for the entity item question
 * @param inspectionEntityItems - list of allowed entity items for the inspection
 * @returns boolean
 */
export function shouldShowConductInspectionHeaderPage(
  headerPage,
  inspection,
  user,
  allowedEntityItems = [],
  inspectionEntityItems = []
) {
  const hasAnyNonAutomaticQuestionNorEntityTypeOfResponse = headerPage.items.some(
    item => !item.params?.automatic && item.response_type !== ResponsesTypes.entityItem
  );

  if (hasAnyNonAutomaticQuestionNorEntityTypeOfResponse) {
    return true;
  }

  const entityItemQuestion = headerPage.items.find(item => item.response_type === ResponsesTypes.entityItem);
  if (!entityItemQuestion) {
    return inspectionEntityItems.length > 1 && !inspection.entity_type_of_response_migrated;
  }

  if (!inspection.autofill_entity) {
    return true;
  }

  return allowedEntityItems.length > 1;
}
